"use client";

export default function ScriptLoader() {
  return null;
}
